module.exports = __webpack_public_path__ + "static/media/img1.84b9c515.png";